import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

//Include Both Helper File with needed methods
import { formatQueryParams } from "helpers/format";
import contentApi from "api/contentApi";

export const getContensApi = async (params: any = {}) => {
  try {
    const response = await contentApi.contents(
      formatQueryParams(params)
    );
    return response;
  } catch (error) {
    return error;
  }
}

export const getContensTBEDApi = async (params: any = {}) => {
  try {
    const response = await contentApi.contentsTBED(
      formatQueryParams(params)
    );
    return response;
  } catch (error) {
    return error;
  }
}

export const getContents = createAsyncThunk("Contents", getContensApi);
export const getAIContentApproval = createAsyncThunk("AIContentApproval", getContensApi);
export const getAIContentTBED = createAsyncThunk("AIContentTBED", getContensTBEDApi);

export const createContent = async (data: any = {}) => {
  try {
    const response = await contentApi.postContent(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const updateContent = async (id: string | number, data: any = {}) => {
  try {
    const response = await contentApi.putContent(id, data);
    return response;
  } catch (error) {
    return error;
  }
};
